import React, { useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components/macro'
import { Input } from '../../Components'
import { search } from '../../Shared/actions'
import { createCondition, removeCondition } from '../actions'
import { conditionBuilder } from '../utils'
import isEqual from 'lodash/isEqual'
import Tag from '../../Shared/components/Tag'
import { ENTER_KEY } from '../../utils/codes'
import { getConditionsBypatientIDAndType } from '../ducks'

const Container = styled.div`
  width: 100%;
  position: relative;
`

const ListContainer = styled.div`
  width: 100%;
  margin-bottom: ${p => p.theme.spacing.medium};
  min-height: 5rem;
  border-radius: 0.25rem;
  border: 1px solid ${p => p.theme.gray};
  background-color: ${p => p.theme.cream};
  display: flex;
  flex-flow: row wrap;
  padding: ${p => p.theme.spacing.small};
  flex: 1;
`

// This component is use without a Questionnaire or Yaml Form. We use it mainly
// for the edit patient form.
const ConditionTagInput = ({ name, placeholder, patientID }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(
      search('Condition', {
        subject: 'Patient/' + patientID
      })
    )
  }, [patientID, dispatch])

  const conditions = useSelector(
    getConditionsBypatientIDAndType(patientID, name)
  )

  const ref = useRef(conditions)

  const [options, setOptions] = useState(conditions)
  const [value, setValue] = useState('')

  // we update the options when we add new one or we delete one
  useEffect(() => {
    if (!isEqual(ref.current, conditions)) {
      setOptions(conditions)
      ref.current = conditions
    }
  }, [conditions])

  const onSubmit = e => {
    e.preventDefault()
    const trimmedValue = (value || '').trim()
    if (trimmedValue !== '') {
      const newCondition = conditionBuilder(trimmedValue, patientID, name)
      dispatch(createCondition(newCondition))
    }
    setValue('')
  }

  const handleTagRemove = item => {
    dispatch(removeCondition(item))
  }

  return (
    <Container>
      <ListContainer>
        {options.map((item, i) => {
          const display = item?.code?.text
          return (
            <Tag
              key={i}
              value={display}
              onRemove={() => handleTagRemove(item)}
            />
          )
        })}
      </ListContainer>
      <Input
        type="text"
        backgroundColor="white"
        label=""
        value={value}
        name={`${name}-input`}
        onKeyPress={e => {
          if (e.which === ENTER_KEY) {
            return onSubmit(e)
          }
        }}
        onChange={e => setValue(e.target.value)}
        onBlur={onSubmit}
        autoComplete="off"
        placeholder={`+  ${placeholder}`}
      />
    </Container>
  )
}

export default ConditionTagInput
